import { createContext, useContext } from "react";
import CommonStore from "./commonStore";
import UserStore from "./userStore";
import ProductStore from "./productStore";
import OrderStore from "./orderStore";
import TicketStore from "./ticketStore";
import ShippingStore from "./shippingStore";

interface Store {
  commonStore: CommonStore;
  userStore: UserStore;
  productStore: ProductStore;
  orderStore: OrderStore;
  ticketStore: TicketStore;
  shippingStore: ShippingStore;
}

export const store: Store = {
  commonStore: new CommonStore(),
  userStore: new UserStore(),
  productStore: new ProductStore(),
  orderStore: new OrderStore(),
  ticketStore: new TicketStore(),
  shippingStore: new ShippingStore(),
};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
